import React from 'react';
interface FormPreviewProps {
  html: string;
  css?: string;
}
export function FormPreview({
  html,
  css
}: FormPreviewProps) {
  // Build the HTML document as a string
  const htmlDoc = '<!DOCTYPE html><html><head><style>{`body { font-family: system-ui, -apple-system, sans-serif; padding: 20px; }' + (css || '') + '`}</style></head><body>' + html + '</body></html>';
  return <div className="w-full h-[500px] bg-gray-50 rounded border border-gray-200 overflow-hidden" data-id="element-300">
      <iframe srcDoc={htmlDoc} title="Form Preview" className="w-full h-full border-0" sandbox="allow-scripts" data-id="element-301" />
    </div>;
}